import React, { useState } from 'react';
import '../styles/AiEditPage.css';
import { baseUrl } from '../config';
import SEO from '../components/SEO';



function AIEditingPage() {
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(URL.createObjectURL(file));
    }
  };

  return (
    <div className="ai-editing-page">
      <SEO
        title="AI Video Editor"
        description="Use ProducerBuddy's AI-powered video editing tool to automatically compose and edit your film footage."
        url="https://producerbuddy.pilomation.com/ai-edit"
        robots="noindex, nofollow"
      />
      <div className="left-section">
        <h3 className="auto-compose-title">Auto compose</h3>
        <div className="steps">
          <button className="step active">1 Upload media</button>
          <button className="step">2 Style</button>
          <button className="step">3 Length</button>
          <button className="step">4 Export</button>
        </div>
        <div className="video-title-section">
          <label htmlFor="videoTitle" className="video-title-label">What’s the title of your video?</label>
          <input
            type="text"
            id="videoTitle"
            placeholder="Italy Trip 2022"
            className="video-title-input"
          />
        </div>
        <div className="media-upload-box">
          <label className="upload-icon">
            <img src="upload_icon.png" alt="Upload" />
            <input
              type="file"
              accept="video/*"
              className="upload-input"
              onChange={handleFileUpload}
            />
          </label>
          {uploadedFile ? (
            <video className="uploaded-media" controls>
              <source src={uploadedFile} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <>
              <p className="upload-text">Click to add media or drag & drop</p>
              <p className="upload-subtext">Your media will be reviewed by AI to compose your video</p>
            </>
          )}
        </div>
        <div className="left-footer-buttons">
          <button className="get-started">Get started</button>
          <button className="learn-more" onClick={() => window.location.href = '/learn-more'}>
            Learn more
          </button>
        </div>
      </div>
      <div className="right-section">
        <div className="right-section-graphic">
          <div className="graphic-background">
            <div className="graphic-play-icon">
              <img src="/path/to/play-icon.png" alt="Play Icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AIEditingPage;

